import api from './api';
import { Commande, CommandeRequest, StatutCommande } from '../types';

export const commandeService = {
  getAll: () => api.get<Commande[]>('/api/commandes').then((r) => r.data),
  getById: (id: number) => api.get<Commande>(`/api/commandes/${id}`).then((r) => r.data),
  getByClient: (clientId: number) => api.get<Commande[]>(`/api/commandes/client/${clientId}`).then((r) => r.data),
  create: (data: CommandeRequest) => api.post<Commande>('/api/commandes', data).then((r) => r.data),
  update: (id: number, data: CommandeRequest) => api.put<Commande>(`/api/commandes/${id}`, data).then((r) => r.data),
  updateStatut: (
    id: number,
    statut: StatutCommande,
    dateEcheance?: string,
    numeroFacture?: string,
    numeroBonCommande?: string,
  ) =>
    api.patch<Commande>(`/api/commandes/${id}/statut`, {
      statut,
      dateEcheance,
      numeroFacture,
      numeroBonCommande,
    }).then((r) => r.data),
  traiterRenouvellement: (id: number) =>
    api.post<Commande>(`/api/commandes/${id}/renouvellement`).then((r) => r.data),
  delete: (id: number) => api.delete(`/api/commandes/${id}`),
};
